/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

export const PROP_TRANSFORM_OFFSET = {};

PROP_TRANSFORM_OFFSET['WATERING_CAN'] = {
	scale: [0.6000005726799265, 0.6000004088611383, 0.6000010361589873],
	position: [0.010108354994668112, -0.25457264416771963, 0.091873750622959],
	quaternion: [
		-0.3039863211134836,
		-0.532162219626983,
		0.3701286997878885,
		0.698140491348056,
	],
};

PROP_TRANSFORM_OFFSET['CAMERA'] = {
	scale: [0.7999999746962384, 0.8000000616558425, 0.7999999635533774],
	position: [-0.08295828795739091, 0.012284192647064263, 0.05664966319542053],
	quaternion: [
		-0.7378421704134571,
		-0.024087440239244324,
		0.0019059157566016572,
		0.6745406527133068,
	],
};

PROP_TRANSFORM_OFFSET['SEEDBOX'] = {
	scale: [1.0000001150316284, 0.9999997419105278, 1.0000005468766155],
	position: [0.14276985726738056, -0.04692265134230311, 0.005411254451788139],
	quaternion: [
		-0.06727127462158666,
		-0.0839183353060185,
		-0.1516255514467989,
		0.9825690722259823,
	],
};

PROP_TRANSFORM_OFFSET['SEEDBAG'] = {
	scale: [0.899999731173479, 0.8999998117385355, 0.8999998696765593],
	position: [0.004996597474657527, 0.0006613937241617407, 0.022534055581253654],
	quaternion: [
		-0.3432018276056474,
		-0.4981064291360081,
		0.5262963469829133,
		0.5975906215370849,
	],
};
